module.exports = __webpack_public_path__ + "img/logo-1.250937f7.svg";